export const getContentMetadataParamsFromQuery = (decodedParamsFromQuery: string): { [key: string]: string } => {
  const pairs = decodedParamsFromQuery.split('&');
  const params: { [key: string]: string } = {};
  pairs.forEach((pair) => {
    const [key, value] = pair.split('=');
    params[key] = value;
  });
  return params;
};
